<form [formGroup]="clientEditForm">
  <div class="form-row row">
    <!-- <div class="form-group col-md-6">
      <div class="logo-container">
        Logo upload component comes here
      </div>
    </div> -->
    <div class="form-group col-md-6">
      <label for="name" class="control-label required">{{'i18n.shared.fields.name' | translate}}</label>
      <input id="name" type="text" class="form-control" formControlName="name" />
      <app-error-messages [control]="clientEditForm.get('name')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="customerNumber" class="control-label required">{{'i18n.domain.client-administration.overview.fields.customerNumber' | translate}}</label>
      <input id="customerNumber" type="text" class="form-control" formControlName="customerNumber" />
      <app-error-messages [control]="clientEditForm.get('customerNumber')"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="vendorNumber" class="control-label required">{{'i18n.domain.client-administration.overview.fields.vendorNumber' | translate}}</label>
      <input id="vendorNumber" type="text" class="form-control" formControlName="vendorNumber" />
      <app-error-messages [control]="clientEditForm.get('vendorNumber')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="address" class="control-label">{{'i18n.shared.fields.address' | translate}}</label>
      <input id="address" type="text" class="form-control" formControlName="address" />
      <app-error-messages [control]="clientEditForm.get('address')"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="zip" class="control-label">{{'i18n.shared.fields.zip' | translate}}</label>
      <input id="zip" type="text" class="form-control" formControlName="zip" />
      <app-error-messages [control]="clientEditForm.get('zip')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="city" class="control-label">{{'i18n.shared.fields.city' | translate}}</label>
      <input id="city" type="text" class="form-control" formControlName="city" />
      <app-error-messages [control]="clientEditForm.get('city')"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="countryCode" class="control-label">{{'i18n.shared.fields.country-code' | translate}}</label>
      <input id="countryCode" type="text" class="form-control" formControlName="countryCode" />
      <app-error-messages [control]="clientEditForm.get('countryCode')"></app-error-messages>
    </div>
  </div>
  @if (isEdit) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label for="active" class="d-block">{{'i18n.shared.fields.active' | translate}}</label>
        <app-yes-no-group-button id="active" formControlName="active"></app-yes-no-group-button>
      </div>
    </div>
  }
</form>
